/**
 * Afuna Aromatics — Sisterhood ritual product page: exact-variant cart
 * quantity + explicit "Add another" action. (R2 Phase 6, items 6-8.)
 *
 * Scope: runs only when the page template is `product.sisterhood-ritual`
 * (guarded again here in addition to the conditional enqueue in
 * layout/theme.liquid), so no other product template is touched.
 *
 * Behaviour:
 * - Shows "In your cart: N" for the currently selected variant, where N is
 *   the confirmed quantity from /cart.js. Hidden when N is 0.
 * - Provides an explicit "Add another" button that adds one more of the
 *   current variant by driving the page's real add-to-cart button (so all
 *   existing success-confirmation, cart events, drawer, and the 12s
 *   auto-close all run unchanged). Quantity is forced to 1 for that click
 *   and the visible quantity selector is restored immediately after.
 * - Re-reads and re-renders after confirmed add / remove / quantity-update
 *   cart events and after a variant change.
 *
 * Progressive enhancement only: on failure it removes its own UI and the
 * native buy-buttons keep working.
 */
(function () {
  'use strict';

  var tplEl = document.querySelector('[data-template]');
  var tpl = (tplEl && tplEl.getAttribute('data-template')) || '';
  if (tpl.indexOf('product.sisterhood-ritual') !== 0) return;

  var CART_EVENT = 'shopify:cart:lines-update';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    try {
      init();
    } catch (err) {
      console.warn('[aa-sisterhood-cart-status] init failed:', err);
    }
  });

  function init() {
    var form = document.querySelector('product-form-component form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var section = form.closest('.shopify-section') || document;
    var buyButtons = form.closest('.buy-buttons-block') || form.parentElement;
    if (!buyButtons) return;

    // ---- Build UI ---------------------------------------------------------
    var wrap = document.createElement('div');
    wrap.className = 'aa-sis-cart-status';
    wrap.hidden = true;

    var count = document.createElement('p');
    count.className = 'aa-sis-cart-status__count';
    count.setAttribute('aria-live', 'polite');
    count.setAttribute('role', 'status');

    var addAnother = document.createElement('button');
    addAnother.type = 'button';
    addAnother.className = 'aa-sis-cart-status__add-another';
    addAnother.textContent = 'Add another';

    wrap.appendChild(count);
    wrap.appendChild(addAnother);
    buyButtons.insertAdjacentElement('afterend', wrap);

    // ---- Current variant ------------------------------------------------
    function currentVariantId() {
      var idInput = form.querySelector('[name="id"]');
      var raw = idInput ? String(idInput.value || '') : '';
      var n = parseInt(raw, 10);
      return isNaN(n) ? null : n;
    }

    // ---- Add-to-cart button (real one on the page) --------------------
    function addToCartButton() {
      return form.querySelector('[ref="addToCartButton"]') ||
        form.querySelector('.product-form__submit') ||
        form.querySelector('button[type="submit"], [type="submit"]');
    }

    function quantityInput() {
      return form.querySelector('.quantity__input') || form.querySelector('[name="quantity"]');
    }

    // ---- Render from /cart.js ----------------------------------------
    function render() {
      var vid = currentVariantId();
      if (vid == null) {
        wrap.hidden = true;
        return;
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !Array.isArray(cart.items)) {
            wrap.hidden = true;
            return;
          }
          var qty = 0;
          for (var i = 0; i < cart.items.length; i++) {
            if (Number(cart.items[i].id) === vid || Number(cart.items[i].variant_id) === vid) {
              qty += Number(cart.items[i].quantity) || 0;
            }
          }
          if (qty > 0) {
            count.textContent = 'In your cart: ' + qty + ' of this size';
            wrap.hidden = false;
          } else {
            wrap.hidden = true;
          }
        })
        .catch(function () { wrap.hidden = true; });
    }

    // ---- "Add another": drive the real add-to-cart, forcing qty 1 ---
    addAnother.addEventListener('click', function () {
      var btn = addToCartButton();
      if (!btn) return;
      var qi = quantityInput();
      var prev = qi ? qi.value : null;
      if (qi) qi.value = '1';
      try {
        btn.dataset.puppet = 'true';
      } catch (e) { /* noop */ }
      btn.click();
      if (qi && prev != null) {
        setTimeout(function () { qi.value = prev; }, 0);
      }
    });

    // ---- React to cart + variant changes ---------------------------
    document.addEventListener(CART_EVENT, function (event) {
      var settle = function () { render(); };
      if (event && event.promise && typeof event.promise.finally === 'function') {
        event.promise.finally(settle);
      } else {
        // small delay so /cart.js reflects the mutation
        setTimeout(settle, 60);
      }
    });

    // Variant change (Horizon dispatches shopify:product:selected on the section)
    section.addEventListener('shopify:product:selected', function (event) {
      var apply = function () { render(); };
      if (event && event.promise && typeof event.promise.then === 'function') {
        event.promise.then(apply).catch(apply);
      } else {
        setTimeout(apply, 60);
      }
    });

    // Fallback: watch the hidden variant id input for programmatic changes.
    var idInput = form.querySelector('[name="id"]');
    if (idInput && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { render(); });
      mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      // value property changes don't always fire mutations; also poll on input/change
      idInput.addEventListener('change', render);
    }

    render();
  }
})();
